// Enterprises approved for the multi-tenant experience. Add new ones here as
// their data pipelines go live — every `multiClient/**/routes.js` file reads
// this list for its menu-visibility filter, so one edit updates every sidebar
// group at once.
//
// Plain `TimHortons` (legacy pipeline) is deliberately absent; those users
// keep routing to the classic `thRoutes` set. `Tim_Hortons_MT` is the
// multi-tenant TH tenant and belongs here.
export const MT_ENTERPRISES = [
  'Tim_Hortons_MT',
  // "TimHortons",
  'DairyQueen',
  'PeachCobblerFactory',
  'Happy',
  'DavesHotChicken',
  'BurgerFi',
];
